module.exports = __webpack_public_path__ + "static/media/fly0176.bcb6fec5.webp";